import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
deleteVideosAction,
deleteVideosrelatedAction,
readLanguageAction,
readVideosAction,
saveCommonsUrlsAction,
saveDownloadVideoUrlLanguageAction,
saveVideoLanguageAction,
saveVideoPreviewLanguageAction,
saveVideoPreviewUrlsAction,
saveVideoUrlLanguageAction,
saveVideosAction,
saveVideosDownloadUrlsAction,
saveVideosThumbNailUrlsAction,
saveVideosUrlsAction,
saveVideosrelatedAction,
translateLanguageAction,
updateCommonsUrlsAction,
updateDownloadVideoUrlLanguageAction,
updateVideoLanguageAction,
updateVideoPreviewLanguageAction,
updateVideoPreviewUrlsAction,
updateVideoUrlLanguageAction,
updateVideosAction,
updateVideosDownloadUrlsAction,
updateVideosThumbNailUrlsAction,
updateVideosUrlsAction,
uploadAssestsAction,
uploadAssestsV2Action,
uploadVideosV2Action,
} from "../../../store/Languages/LanguageAction";
import Toastiy from "../../../components/universal/Toastiy";
import { useNavigate } from "react-router-dom";
import {
deleteVideoLayoutAction,
readVideoLayoutAction,
saveVideoLayoutAction,
updateVideoLayoutAction,
} from "../../../store/Layout/LayoutAction";
import { setShowNavigationAlertAction } from "../../../store/GlobalLoader/GlobalLoaderAction";
import { sendCustomNotificationAction } from "../../../store/Notifications/NotificationAction";
import { fetchChurchesRequest } from "../../../store/Churches/actions";
import { saveChurchRequest,deleteChurchRequest,updateChurchRequest } from "../../../store/Churches/actions"; // ✅ import save action
import { saveProgramRequest,updateProgramRequest,deleteProgramRequest } from "../../../store/Program/programActions";
import {saveProgramCoverImageRequest,updateProgramCoverImageRequest} from '../../../store/ProgramCoverImage/actions'
import { saveProgramLanguageMetaRequest } from "../../../store/ProgramLanguage/action";
import {saveProgramVideoRequest} from "../../../store/ProgramVIdeo/programVideosActions"
import { toast } from "react-toastify";
const ChurchHooks = () => {
const [value, setValue] = useState("");
const onChangeSearchBar = (e) => {
    setValue(e.target.value);
};

return { value, onChangeSearchBar };
};

export default ChurchHooks;

export const AllChurchHooks = () => {
const dispatch = useDispatch();

const [value, setValue] = useState("");
const [reloadData, setReloadData] = useState(false);
const fetchAllChurches = (page, limit, searchCriteria = {}, callbackFn, churchId = "") => {
    dispatch(
      fetchChurchesRequest({
        apiPayloadRequest: {
          page: page,
          limit: limit,
          searchCriteria: searchCriteria,
          _id:churchId
        },
        callback: (Data) => {
          if (Data?.type === 1) {
            if (callbackFn) {
              // Extract all programs and attach church id
              let programs = (Data?.data ?? []).flatMap((church) =>
                (church.programs ?? []).map((program) => ({
                  ...program,
                  churchId: church._id,
                }))
              );

              // ✅ filter if churchId is selected
              if (churchId) {
                programs = programs.filter((program) => program.churchId === churchId);
              }

              callbackFn({
                data: programs,
                total: programs.length,
              });
            }
          } else if (callbackFn) {
            callbackFn({ data: [], total: 0 });
          }
        },
      })
    );
  };




const onChangeSearchBar = (e) => {
    setValue(e.target.value);
};

const handleDelete = (row) => {
    return new Promise((resolve) => {
      if (!row?.programObjId || !row?.churchId) {
        resolve({ type: 0, programObjId: row?.programObjId || null, error: "Missing program or church ID" });
        return;
      }

      dispatch(
        deleteProgramRequest(
          { _id: row.churchId, programObjId: row.programObjId },
          (res) => resolve(res) // always resolves with {type, programObjId, message?, error?}
        )
      );
    });
  };











const getVideoDeletedResponse = (data, message) => {
    if (data?.type === 1) {
    Toastiy(message, data?.type);
    } else {
    Toastiy("Issue performing the operation, contact admin!!", data?.type);
    }
};
return {
    value,
    onChangeSearchBar,
    handleDelete,
    reloadData,
    setReloadData,
    fetchAllChurches,

};
};

export const AddChurchHooks = (setLoading, data) => {
// search logic here
const [options, setOptions] = useState([]);
const [value, setValue] = useState("");
const [activeTab, setActiveTab] = useState("en");
const [activeLanguageDetails, setActiveLanguageDetails] = useState({
    language_code: "en",
    language_name: "English",
});
const [allLanguageData, setAllLanguageData] = useState([]);
const [readLanguageData, setReadLanguageData] = useState([]);
const [selectedOptions, setSelectedOptions] = useState([]);
const [selectedRelatedVideoIndex, setSelectedRelatedVideoIndex] = useState(null);
const [relatedVideos, setRelatedVideos] = useState([]);
const [thumbnailImage, setThumbnailImage] = useState(null);

const dispatch = useDispatch();

const onChangeSearchBar = (e) => {
    setValue(e.target.value);
};
// add category logic here

const initialLayoutValues = {
    _id: "",
    mobile_layout: "1",
    layout_name: "",
    order: "",
    // title: "",
    // subtitle: "",
    // expiry: "",
};

const initialStateValues = {
    video_title: "",
    video_description: "",
    _id: "",
};

const [layoutValues, setLayoutValues] = useState(initialLayoutValues);
const [addedLayout, setAddedLayout] = useState(false);
const initialCarecellValues={
    type_of_url: "",
    url_link: "",
}
const [carecellInputs, setcarecellInputs] = useState(initialCarecellValues);
const initialVideoValues = {
    _id: "",                // church id
  typeofProgram: "",      // 1 or 2
  programName: "",
  description: "",
  programDate: "",
  programTime: "",
  placename: "",
  latitude: "",
  longitude: "",
  liveStreamUrl: "",
  contactperson: "",
  contactphone: "",
  contactemail: "",
  author: "",
  subscriptionUrl: "",
  registerUrl: "",
};

const languages = [
    "English",
    "hindi",
    "tamil",
    "telugu",
    "Malayalam",
    "Spanish",
    "Marathi",
    "Urdu",
    "Oriya",
    "kanada",
    "Bengali",
]; // List of languages

const [downloadValues, setDownloadValues] = useState("");
const [downloadUrl, setDownloadUrl] = useState("");
const [thumbNailValues, setThumbNailValues] = useState("");
const [thumbNailUrl, setThumbNailUrl] = useState("");
const [inputs, setInputs] = useState("");
const [showVideoLibraryModal, setShowVideoLibraryModal] = useState(false);
const [videoInputs, setVideoInputs] = useState(initialVideoValues);
const [videoErrors, setVideoErrors] = useState({
    video_title: false,
    video_description: false,
    video_urls: false,
    video_download_urls: false,
    video_thumbnails_urls: false,
    video_common_thumbnails_urls: false,
    video_preview_urls: false,
    selectedOptions: false,
});
const [videoset,setvideoset]=useState([]);
const [isLive,setIslive] =useState(false)
const [isDefault,setIsDefault] =useState(false)
const [currentInputs, setCurrentInputs] = useState();
const [languagemeta, setLanguagemeta] = useState();

const [videoUrlsInputs, setVideoUrlsInputs] = useState(initialStateValues);
const [UdownloadrlsInputs, setDownloadUrlsInputs] = useState(initialStateValues);
const [tumbNailUrlsInputs, setTumbNailUrlsInputs] = useState(initialStateValues);
const [commonVideoUrlsInputs, setCommonUrlsInputs] = useState(initialStateValues);
const [previewUrlsInputs, setPreviewUrlsInputs] = useState(initialStateValues);

const [videoUrlsInputsCheck, setVideoUrlsInputsCheck] = useState();
const [UdownloadrlsInputsCheck, setDownloadUrlsInputsCheck] = useState();
const [tumbNailUrlsInputsCheck, setTumbNailUrlsInputsCheck] = useState();
const [commonUrlsInputsCheck, setCommonUrlsInputsCheck] = useState();
const [previewUrlsInputsCheck, setPreviewUrlsInputsCheck] = useState();
const [layoutInfo, setLayoutInfo] = useState(false);
const [layoutArray, setLayoutArray] = useState([]);
const [isLayoutEdit, setIsLayoutEdit] = useState(false);
const [editLayoutIndex, setEditLayoutIndex] = useState(null);
const [editTargetLayout, setEditTargetLayout] = useState("");
const [ImageSet,setImageSet] =useState();
const initialChurchValues = {
    _id: "",
    church_name: "",
    church_description: "",
    church_address: "",
    church_email: "",
    church_phone: "",
    church_website: "",
    church_latitude: "",
    church_longitude: "",
};
const [churchInputs, setChurchInputs] = useState(initialChurchValues);
// 🔹 State for previous (existing) values when editing
const [previousChurchInputs, setPreviousChurchInputs] = useState({
    _id: "",
    church_name: "",
    church_description: "",
    church_address: "",
});

// 🔹 Validation errors
const [churchErrors, setChurchErrors] = useState({
    church_name: false,
    church_description: false,
    church_address: false,
});

// 🔹 Loader (renamed)
const [savingChurch, setSavingChurch] = useState(false);

// 🔹 Local store for churches (instead of DB)
const [churches, setChurches] = useState([]);
const [saveSuccess, setSaveSuccess] = useState(false);


const navigate = useNavigate();


useEffect(() => {
    return () => setShowNavigationAlert(false);
}, []);

const setShowNavigationAlert = (value) => {
    dispatch(setShowNavigationAlertAction(value));
};

const combineStateKeys = (rowData) => {
    const values = Object.values({
        programName: rowData?.programName,
        description: rowData?.description,
        placename: rowData?.placename,
        liveStreamUrl: rowData?.liveStreamUrl,
        contactemail: rowData?.contactemail,


    });
    const combinedString = values.join("///");
    return combinedString;
};

const updateStateWithTranslation = (rowData) => {
    const combinedText = combineStateKeys(rowData);

    dispatch(
    translateLanguageAction({
        apiPayloadRequest: {
        targetcode: activeTab,
        translatetext: combinedText,
        },
        callback: (res) => {
        if (res?.type === 1) {
            onTranslateSuccess(res?.data);
        } else if (res?.type === 2) {
            Toastiy("Language Translation failed!!");
            Toastiy(res?.message);
        }
        },
    })
    );
};

const onTranslateSuccess = (data) => {
        const arrayOfValues = data.split("///");
    const arrayOfKeys = Object.keys({
        programName: videoInputs?.programName,
        description: videoInputs?.description,
        placename:videoInputs?.placename,
        liveStreamUrl:videoInputs?.liveStreamUrl,
        contactemail:videoInputs?.contactemail
    });

    for (let key in arrayOfKeys) {
    setVideoInputs((preState) => ({
        ...preState,
        [arrayOfKeys[key]]: arrayOfValues[key],
    }));
    }
    setShowNavigationAlert(true);
};

// const getRelatedVideos = (response) => {
//     if (response?.type === 1) {
//     response?.data?.map((item) =>
//         setOptions((prevData) => [
//         ...prevData,
//         {
//             value: item?._id || "",
//             label: item?.video_title || "",
//             image: item?.tumbnailurls?.length > 0 ? item?.tumbnailurls[0]?.url_link : "",
//         },
//         ])
//     );
//     } else {
//     Toastiy("Failed To Get Related Videos Data");
//     }
// };

const handleAddLayoutToArray = () => {
    if (videoInputs?._id !== undefined && videoInputs?._id !== "") {
    dispatch(
        saveVideoLayoutAction({
        apiPayloadRequest: {
            _id: layoutValues?._id,
            videoObjId: videoInputs?._id,
            order: layoutValues?.order,
            // expiry: layoutValues?.expiry,
            // title: layoutValues?.title,
            // subtitle: layoutValues?.subtitle,
        },
        callback: (res) => {
            if (res?.type === 1) {
            Toastiy("Layout Added Successfully!", 1);
            setLayoutArray((prev) => [...prev, layoutValues]);
            setLayoutValues(initialLayoutValues);
            setAddedLayout(true);
            }
        },
        })
    );
    } else {
    setLayoutArray((prev) => [...prev, layoutValues]);
    setLayoutValues(initialLayoutValues);
    setAddedLayout(true);
    }
};

const handleDeleteLayoutFromArray = (id) => {
    if (videoInputs?._id !== undefined && videoInputs?._id !== "") {
    dispatch(
        deleteVideoLayoutAction({
        apiPayloadRequest: {
            _id: id,
            videoObjId: videoInputs?._id,
        },
        callback: (res) => {
            if (res?.type === 1) {
            const updatedArray = layoutArray.filter((item) => item._id !== id);
            setLayoutArray(updatedArray);
            Toastiy("Layout Deleted Successfully!", 1);
            }
        },
        })
    );
    } else {
    const updatedArray = layoutArray.filter((item) => item._id !== id);
    setLayoutArray(updatedArray);
    }
};

const handleLayoutUpdate = () => {
    if (videoInputs?._id !== undefined && videoInputs?._id !== "") {
    dispatch(
        updateVideoLayoutAction({
        apiPayloadRequest: {
            _id: layoutValues?._id,
            videoObjId: videoInputs?._id,
            order: layoutValues?.order,
            // title: layoutArray._id,
            // subtitle: layoutArray._id,
            // expiry: layoutArray._id,
        },
        callback: (res) => {
            if (res?.type === 1) {
            setLayoutValues(initialLayoutValues);
            setIsLayoutEdit(false);
            Toastiy("Layout Updated Successfully!", 1);
            setShowNavigationAlert(false);
            }
        },
        })
    );
    } else {
    setLayoutValues(initialLayoutValues);
    setIsLayoutEdit(false);
    setShowNavigationAlert(true);
    }
};

const handleDateChange = (value) => {
    setLayoutValues((prev) => ({
    ...prev,
    expiry: value,
    }));
    setShowNavigationAlert(true);
};

const handleVideoLayoutChange = (event) => {
    if (isLayoutEdit) {
    const { name, value } = event.target;
    setLayoutValues((prev) => ({
        ...prev,
        [name]: value,
    }));

    setLayoutArray((prev) => {
        const updatedArray = [...prev];

        updatedArray[editLayoutIndex] = {
        ...updatedArray[editLayoutIndex],
        [name]: value,
        };
        return updatedArray;
    });
    } else {
    const { name, value } = event.target;
    setLayoutValues((prev) => ({
        ...prev,
        [name]: value,
    }));
    setShowNavigationAlert(true);
    }
};

const handleVideoDateChange = (value) => {
    setLayoutValues((prev) => ({
    ...prev,
    expiry: value,
    }));
    setShowNavigationAlert(true);
};

const handleDropdownChange = (selectedValues) => {
                const videoItem = {
    value: selectedValues?._id,
    label: selectedValues?.video_title,
    image:
        selectedValues?.tumbnailurls?.length > 0 ? selectedValues?.tumbnailurls[0]?.url_link : "",
    order:
        selectedRelatedVideoIndex !== null
        ? selectedOptions[selectedRelatedVideoIndex]?.order
        : selectedOptions?.length + 1,
    };

    if (data?._id !== "" && data?._id !== undefined) {
    if (selectedRelatedVideoIndex !== null && selectedOptions[selectedRelatedVideoIndex]?.value) {
        dispatch(
        deleteVideosrelatedAction({
            apiPayloadRequest: {
            _id: data?._id,
            videoObjId: selectedOptions[selectedRelatedVideoIndex]?.value,
            },
            callback: (res) => {
            if (res?.type === 1) {
                //show message
                dispatch(
                saveVideosrelatedAction({
                    apiPayloadRequest: {
                    _id: data?._id,
                    videoObjId: videoItem?.value,
                    },
                    callback: (res) => {
                    if (res?.type === 1) {
                        Toastiy("Related Video Updated Successfully!", 1);
                        setSelectedOptions((prev) =>
                        prev?.map((d, i) => (i === selectedRelatedVideoIndex ? videoItem : d))
                        );
                    } else {
                        Toastiy("Failed to Update Video");
                    }
                    },
                })
                );
            }
            },
        })
        );
    } else {
        dispatch(
        saveVideosrelatedAction({
            apiPayloadRequest: {
            _id: data?._id,
            videoObjId: videoItem?.value,
            },
            callback: (res) => {
            if (res?.type === 1) {
                Toastiy("Related Video Added Successfully!", 1);
                setSelectedOptions((prev) => [...prev, videoItem]);
            } else {
                Toastiy("Failed to Add Video");
            }
            },
        })
        );
    }
    } else {
    if (selectedRelatedVideoIndex !== null) {
        setSelectedOptions((prev) =>
        prev?.map((d, i) => (i === selectedRelatedVideoIndex ? videoItem : d))
        );
    } else {
        setSelectedOptions((prev) => [...prev, videoItem]);
    }
    setShowNavigationAlert(true);
    }
    setShowVideoLibraryModal(false);
    setVideoErrors({ ...videoErrors, selectedOptions: false });
    setSelectedRelatedVideoIndex(null);
};

const deleteRelatedVideo = (videoObjId) => {
    if (data?._id) {
    dispatch(
        deleteVideosrelatedAction({
        apiPayloadRequest: {
            _id: data?._id,
            videoObjId: videoObjId,
        },
        callback: (res) => {
            if (res?.type === 1) {
            Toastiy("Related Video Removed Successfully!", 1);
            setSelectedOptions((prev) => prev.filter((item) => item.value !== videoObjId));
            } else {
            Toastiy("Failed to Delete Video");
            }
        },
        })
    );
    } else {
    setSelectedOptions((prev) => prev.filter((item) => item.value !== videoObjId));
    }
    setSelectedRelatedVideoIndex(null);
};


const getAllLanguageResponse = (response) => {
    if (response?.type === 1) {
    setReadLanguageData(response?.data);
    setLoading(false);
    }
};

// const handleInputChange = (event, setState) => {
//     const { name, value } = event.target;
//     setcarecellInputs((prevInputs) => ({
//         ...prevInputs,
//         url_link: value,
//       }));
//     setVideoErrors({
//     ...videoErrors,
//     video_urls: false,
//     video_download_urls: false,
//     video_thumbnails_urls: false,
//     video_common_thumbnails_urls: false,
//     video_preview_urls: false,
//     });
//     setShowNavigationAlert(true);
// };
const handleInputChange = (event, setState) => {
    const { name, value } = event.target;
            setState((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setVideoErrors({
      ...videoErrors,
      video_urls: false,
      video_download_urls: false,
      video_thumbnails_urls: false,
      video_common_thumbnails_urls: false,
      video_preview_urls: false,
    });
    setShowNavigationAlert(true);
  };

const handleDownloadInputChange = (event) => {
    const { name, value } = event.target;
    setDownloadUrlsInputs((prevData) => ({
    ...prevData,
    [name]: value,
    }));
    setVideoErrors({ ...videoErrors, video_download_urls: false });
    setShowNavigationAlert(true);
};

const handleTumbNailInputChange = (event) => {
    const { name, value } = event.target;
    setTumbNailUrlsInputs((prevData) => ({
    ...prevData,
    [name]: value,
    }));
    setVideoErrors({ ...videoErrors, video_thumbnails_urls: false });
    setShowNavigationAlert(true);
};

const handleCommonTumbNailInputChange = (event) => {
    const { name, value } = event.target;
    setCommonUrlsInputs((prevData) => ({
    ...prevData,
    [name]: value,
    }));
    setVideoErrors({ ...videoErrors, video_thumbnails_urls: false });
    setShowNavigationAlert(true);
};

const handleChange = (event) => {
    const { name, value } = event.target;
            setVideoInputs((prevData) => ({
    ...prevData,
    [name]: value,
}));

setChurchErrors({ ...churchErrors, [name]: false });
setShowNavigationAlert(true);
};
const handleCarecellChange =(event)=>{
    const { name, value } = event.target;
        setcarecellInputs((prevData) => ({
    ...prevData,
    [name]: value,
}));

setChurchErrors({ ...churchErrors, [name]: false });
setShowNavigationAlert(true);
}

// const handleFileInputChange = (
//     setState,
//     keyName,
//     file,
//     type,
//     uploadProgressId = null,
//     downloadable = false,
//     errorKeyName = ""
//   ) => {
//     setLoading(true);
//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("downloadable", downloadable);

//     const callback = (res) => {
//       // ✅ 1. update preview state (UploadControlsV2 thumbnails)
//       setcarecellInputs((prevInputs) => ({
//         ...prevInputs,
//         url_link: res?.url,
//       }));

//       // ✅ 2. update churchInputs with only the web URL
//       if (keyName === "webUploadUrl") {
//         setcarecellInputs((prevInputs) => ({
//           ...prevInputs,
//           url_link: res?.url, // store only web logo URL
//         }));
//       }

//       setVideoErrors({ ...videoErrors, [errorKeyName]: false });
//       setLoading(false);
//       setShowNavigationAlert(true);
//     };

//     if (type === "videos") {
//       dispatch(
//         uploadVideosV2Action({
//           apiPayloadRequest: formData,
//           uploadProgressId,
//           callback,
//         })
//       );
//     } else {
//       dispatch(
//         uploadAssestsV2Action({
//           apiPayloadRequest: formData,
//           uploadProgressId,
//           callback,
//         })
//       );
//     }
//   };
const handleFileInputChange = (
    setState,
    keyName,
    file,
    type,
    uploadProgressId = null,
    downloadable = false,
    errorKeyName = ""
  ) => {

    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("downloadable", downloadable);
    if (type === "videos") {
      dispatch(
        uploadVideosV2Action({
          apiPayloadRequest: formData,
          uploadProgressId: uploadProgressId,
          callback: (res) => {
            setState((prevInputs) => ({
              ...prevInputs,
              [keyName]: res?.url,
            }));
            setVideoErrors({ ...videoErrors, [errorKeyName]: false });
            setLoading(false);
            setShowNavigationAlert(true);
          },
        })
      );
    } else {
      dispatch(
        uploadAssestsV2Action({
          apiPayloadRequest: formData,
          uploadProgressId: uploadProgressId,
          callback: (res) => {
            setState((prevInputs) => ({
              ...prevInputs,
              [keyName]: res?.url,
            }));
            setVideoErrors({ ...videoErrors, [errorKeyName]: false });
            setLoading(false);
            setShowNavigationAlert(true);
          },
        })
      );
    }
  };

const handleFileDownloadInputChange = (language, field, file, value) => {
    const formData = new FormData();
    formData.append("file", file);
    dispatch(
    uploadAssestsAction({
        apiPayloadRequest: formData,
        callback: (res) => {
        setDownloadUrl(res?.url);
        setDownloadUrlsInputs((prevInputs) => ({
            ...prevInputs,
            [field]: res?.url,
        }));
        setVideoErrors({ ...videoErrors, video_download_urls: false });
        setShowNavigationAlert(true);
        },
    })
    );
    setDownloadValues(value);
};

const handleFiletumbNailInputChange = (language, field, file, value) => {
    const formData = new FormData();
    formData.append("file", file);
    dispatch(
    uploadAssestsAction({
        apiPayloadRequest: formData,
        callback: (res) => {
        setThumbNailUrl(res?.url);
        setTumbNailUrlsInputs((prevInputs) => ({
            ...prevInputs,
            [field]: res?.url,
        }));
        setVideoErrors({ ...videoErrors, video_thumbnails_urls: false });
        setShowNavigationAlert(true);
        },
    })
    );
    setThumbNailValues(value);
};

const handleRelatedVideosChange = (selectedOptions) => {
    setInputs((prevInputs) => ({
    ...prevInputs,
    [activeTab]: {
        ...prevInputs[activeTab],
        relatedVideos: selectedOptions.map((option) => option.value),
    },
    }));
    setShowNavigationAlert(true);
    // setVideoErrors({ ...videoErrors, selectedOptions: false });
};

const handleVideoDescriptionChange = (e) => {
    handleInputChange(activeTab, "videoDescription", e.target.value);
    setShowNavigationAlert(true);
};

const videoData =
    videoUrlsInputs.mobileUploadUrl !== ""
    ? videoUrlsInputs.mobileUploadUrl
    : videoUrlsInputs.webUploadUrl !== ""
    ? videoUrlsInputs.webUploadUrl
    : videoUrlsInputs.tabletUploadUrl;

const downloadData =
    UdownloadrlsInputs.mobileUploadUrl !== ""
    ? UdownloadrlsInputs.mobileUploadUrl
    : UdownloadrlsInputs.webUploadUrl !== ""
    ? UdownloadrlsInputs.webUploadUrl
    : UdownloadrlsInputs.tabletUploadUrl;

const tumbNailData =
    tumbNailUrlsInputs.mobileUploadUrl !== ""
    ? tumbNailUrlsInputs.mobileUploadUrl
    : tumbNailUrlsInputs.webUploadUrl !== ""
    ? tumbNailUrlsInputs.webUploadUrl
    : tumbNailUrlsInputs.tabletUploadUrl;

    const handleSave = (id, onClose) => {
        return new Promise((resolve, reject) => {
          if (typeof setSavingChurch === "function") setSavingChurch(true);

          const payload = {
            _id: id || "",
            typeofProgram: videoInputs?.typeofProgram?.trim() || "",
            programName: videoInputs?.programName?.trim() || "",
            description: videoInputs?.description?.trim() || "",
            programDate: videoInputs?.programDate || "",
            programTime: videoInputs?.programTime || "",
            placename: videoInputs?.placename?.trim() || "",
            latitude: videoInputs?.latitude || "",
            longitude: videoInputs?.longitude || "",
            liveStreamUrl: videoInputs?.liveStreamUrl || "",
            subscriptionUrl: videoInputs?.subscriptionUrl || "", // 🆕
            registerUrl: videoInputs?.registerUrl || "",
            contactperson: videoInputs?.contactperson?.trim() || "",
            contactphone: videoInputs?.contactphone || "",
            contactemail: videoInputs?.contactemail || "",
            author: videoInputs?.author?.trim() || "",
          };

          const programCallback = (res) => {
            if (typeof setSavingChurch === "function") setSavingChurch(false);

            const programObjId = res?.data?.programObjId || res?.programObjId;
            if (res?.type !== 1 || !programObjId) {
              toast.error(res?.error || "Program save failed.");
              reject(res);
              return;
            }

            toast.success("Program saved successfully!");
            onClose?.();
            if (typeof setVideoInputs === "function") setVideoInputs(initialVideoValues);

            /* ---------------------------------------------------------
               1️⃣ SAVE PROGRAM COVER IMAGES (FIRE & FORGET)
            ----------------------------------------------------------*/
            const imageArray = ImageSet?.target?.value || [];

            if (Array.isArray(imageArray) && imageArray.length > 0) {
              imageArray.forEach((img) => {
                const coverImagePayload = {
                  _id: payload._id,
                  programObjId,
                  galleryObjId: img?.id || "",
                  mobilesetting: img?.mobile?.setting || img?.mobilesetting || "contain",
                  tabletsetting: img?.tablet?.setting || img?.tabletsetting || "contain",
                  dashboardsetting: img?.web?.setting || img?.dashboardsetting || "cover",
                  default: img?.default ? "true" : "false",
                };


                dispatch(
                  saveProgramCoverImageRequest({
                    apiPayloadRequest: coverImagePayload,
                    callback: (coverRes) => {
                      if (coverRes?.type === 1) {
                                              } else {
                                              }
                    },
                  })
                );
              });
            }

            /* ---------------------------------------------------------
               2️⃣ SAVE PROGRAM VIDEOS FROM VIDEOSET STATE
               - Take videoObjId from videoset.target.value array
               - Run API for each video in the array
            ----------------------------------------------------------*/

            const videoArray = videoset?.target?.value || [];


            if (Array.isArray(videoArray) && videoArray.length > 0) {
              // Counter to track completed video saves
              let completedSaves = 0;
              const totalVideos = videoArray.length;

              videoArray.forEach((video, index) => {
                // Get video ID from the video object
                const videoObjId = video?.id || video?.videoObjId || "";

                if (!videoObjId) {
                                    completedSaves++;
                  return;
                }

                // Get thumbnail ID if available
                const thumbnailId = video?.thumbnailId || "";

                // Check if video should be default (first video is default)
                // const isDefaultVal = index === 0 ? "true" : "false";

                // Use live from video object or fallback to isLive state
                // const isLiveVal = (video?.live || isLive) ? "true" : "false";

                const videoPayload = {
                  _id: payload._id,
                  programObjId,
                  videoObjId: videoObjId,
                  thumbnailId: thumbnailId, // Optional: pass thumbnail if your API supports it
                  default: isDefault,
                  live: isLive,
                };


                dispatch(
                  saveProgramVideoRequest(
                    videoPayload,
                    (videoRes) => {

                      completedSaves++;

                      if (videoRes?.type === 1) {

                        // Show success toast when all videos are saved
                        if (completedSaves === totalVideos) {
                          // toast.success(`${totalVideos} video(s) saved successfully!`);
                        }
                      } else {
                                                toast.error(`Failed to save video ${index + 1}`);
                      }
                    }
                  )
                );
              });

              // Show initial toast
              // toast.info(`Saving ${totalVideos} video(s)...`);
            } else {
                          }

            // Clear videoset state after saving
            if (typeof setvideoset === "function") {
              setvideoset({ target: { name: "thumbnail", value: [] } });
            }

            resolve(res);
          };

          // MAIN SAVE DISPATCH
                    dispatch(saveProgramRequest(payload, programCallback));
        });
      };










    //   const handleSaveCarecellCoverImage = (rowData) => {

    //     const typeMap = {
    //       webUploadUrl: "0",
    //       tabletUploadUrl: "1",
    //       mobileUploadUrl: "2",
    //     };

    //     const payload = {
    //       _id: rowData?.churchId || "",
    //       programObjId: rowData?.programObjId || "",
    //       type_of_url: typeMap[carecellInputs?.type_of_url] || "",
    //       url_link: carecellInputs?.url_link || "",
    //     };


    //     dispatch(
    //       saveProgramCoverImageRequest(payload, (res) => {
    //         if (res?.type === 1) {
    //           toast.success("Cover Image Saved Successfully");
    //         } else {
    //           toast.error("Save failed: " + (res?.error || "Unknown error"));
    //         }
    //       })
    //     );
    //   };


    const handleUpdateChurch = (church, rowData, data) => {
        return new Promise((resolve, reject) => {

          if (typeof setSavingChurch === "function") setSavingChurch(true);

          // Step 1: Prepare main program payload
          const payload = {
            _id: church?._id || videoInputs?.church_id || rowData?.churchId || "",
            programObjId: data?.programObjId || videoInputs?.programObjId || rowData?._id || "",
            typeofProgram: videoInputs?.typeofProgram?.trim() || rowData?.typeofProgram || "",
            programName: videoInputs?.programName?.trim() || rowData?.programName || "",
            description: videoInputs?.description?.trim() || rowData?.description || "",
            programDate: videoInputs?.programDate || rowData?.programDate || "",
            programTime: videoInputs?.programTime || rowData?.programTime || "",
            placename: videoInputs?.placename?.trim() || rowData?.placename || "",
            latitude: videoInputs?.latitude || rowData?.latitude || "",
            longitude: videoInputs?.longitude || rowData?.longitude || "",
            liveStreamUrl: videoInputs?.liveStreamUrl || rowData?.liveStreamUrl || "",
            subscriptionUrl: videoInputs?.subscriptionUrl || rowData?.subscriptionUrl || "", // 🆕
            registerUrl: videoInputs?.registerUrl || rowData?.registerUrl || "",
            contactperson: videoInputs?.contactperson?.trim() || rowData?.contactperson || "",
            contactphone: videoInputs?.contactphone || rowData?.contactphone || "",
            contactemail: videoInputs?.contactemail || rowData?.contactemail || "",
            author: videoInputs?.author?.trim() || rowData?.author || "",
          };


          if (ImageSet?.target?.value) {
                      }

          if (videoset?.target?.value) {
                      }

          // Get existing cover image IDs from rowData
          const existingCoverImageIds = data?.programcoverImage?.map(img => {
            const id = img?.galleryObjId || img?.gallery?._id || img?.id;
            return id;
          }).filter(id => id && id.trim() !== "") || [];


          // Get existing video IDs from rowData.programVideos
          const existingVideoIds = data?.programVideos?.map(video => {
            const videoData = video.video || {};
            const id = videoData._id || video.videoObjId || video.programvideoObjId;
            return id;
          }).filter(id => id && id.trim() !== "") || [];


          // Step 2: Program update callback
          const programUpdateCallback = (res) => {
            if (typeof setSavingChurch === "function") setSavingChurch(false);

            if (res?.type !== 1) {
              toast.error(res?.error || "Program update failed.");
              reject(res);
              return;
            }

            toast.success("Program updated successfully!");

            // Get the programObjId from response or existing data
            const programObjId = res?.data?.programObjId || payload.programObjId;

            /* ---------------------------------------------------------
                1️⃣ SAVE PROGRAM COVER IMAGES IF ImageSet HAS VALUE
                - Only save images that don't already exist in programcoverImage
            ----------------------------------------------------------*/
            const imageArray = ImageSet?.target?.value || [];

            if (Array.isArray(imageArray) && imageArray.length > 0 && programObjId) {

              // Filter out images that already exist in programcoverImage
              const newImages = imageArray.filter(img => {
                const imageId = img?.id || img?.galleryObjId || "";
                const isDuplicate = existingCoverImageIds.includes(imageId);
                if (isDuplicate) {
                                  }
                return !isDuplicate;
              });


              if (newImages.length > 0) {
                newImages.forEach((img, index) => {
                  const imageId = img?.id || img?.galleryObjId || "";
                  const galleryObj = img?.gallery || img;

                  const coverImagePayload = {
                    _id: payload._id, // Church ID
                    programObjId: programObjId, // Program ID
                    galleryObjId: imageId,
                    mobilesetting: galleryObj?.mobile?.setting || img?.mobile?.setting || img?.mobilesetting || "contain",
                    tabletsetting: galleryObj?.tablet?.setting || img?.tablet?.setting || img?.tabletsetting || "contain",
                    dashboardsetting: galleryObj?.web?.setting || img?.web?.setting || img?.dashboardsetting || "cover",
                    default: (galleryObj?.default || img?.default) ? "true" : "false",
                  };


                  dispatch(
                    saveProgramCoverImageRequest({
                      apiPayloadRequest: coverImagePayload,
                      callback: (coverRes) => {
                        if (coverRes?.type === 1) {
                                                    existingCoverImageIds.push(imageId);
                        } else {
                                                  }
                      },
                    })
                  );
                });

                // toast.info(`Saving ${newImages.length} new cover image(s)...`);
              } else {
                                // toast.info("All cover images already exist in program, no new images saved.");
              }
            } else if (imageArray.length === 0) {
                          } else if (!programObjId) {
                          }

            /* ---------------------------------------------------------
                2️⃣ SAVE PROGRAM VIDEOS FROM VIDEOSET STATE
                - Take videoObjId from videoset.target.value array
                - Only save videos that don't already exist in programVideos
                - Run API for each new video in the array
            ----------------------------------------------------------*/

            const videoArray = videoset?.target?.value || [];


            if (Array.isArray(videoArray) && videoArray.length > 0 && programObjId) {

              // Filter out videos that already exist in programVideos
              const newVideos = videoArray.filter(video => {
                const videoId = video?.id || video?.videoObjId || "";
                const isDuplicate = existingVideoIds.includes(videoId);
                if (isDuplicate) {
                                  }
                return !isDuplicate;
              });


              if (newVideos.length > 0) {
                // Counter to track completed video saves
                let completedSaves = 0;
                const totalVideos = newVideos.length;

                newVideos.forEach((video, index) => {
                  // Get video ID from the video object
                  const videoObjId = video?.id || video?.videoObjId || "";

                  if (!videoObjId) {
                                        completedSaves++;
                    return;
                  }

                  // Get thumbnail ID if available
                  const thumbnailId = video?.thumbnailId || "";

                  // Check if video should be default (first video is default)
                  // Note: For update, you might want to check if any video is already default
                  // or let the user specify which one should be default
                //   const isDefault = (video?.default || isDefault) ? "true" : "false";

                  // Use live from video object or fallback to isLive state
                //   const isLive = (video?.live || isLive) ? "true" : "false";

                  const videoPayload = {
                    _id: payload._id,
                    programObjId,
                    videoObjId: videoObjId,
                    thumbnailId: thumbnailId, // Optional: pass thumbnail if your API supports it
                    default: isDefault,
                    live: isLive,
                  };


                  dispatch(
                    saveProgramVideoRequest(
                      videoPayload,
                      (videoRes) => {

                        completedSaves++;

                        if (videoRes?.type === 1) {

                          // Show success toast when all videos are saved
                          if (completedSaves === totalVideos) {
                            // toast.success(`${totalVideos} video(s) saved successfully!`);
                          }
                        } else {
                                                    toast.error(`Failed to save video ${index + 1}`);
                        }
                      }
                    )
                  );
                });

                // Show initial toast
                // toast.info(`Saving ${totalVideos} new video(s)...`);
              } else {
                                // toast.info("All videos already exist in program, no new videos saved.");
              }
            } else if (videoArray.length === 0) {
                          } else if (!programObjId) {
                          }

            /* ---------------------------------------------------------
                3️⃣ HANDLE VIDEO DELETIONS (Optional - if you want to remove deleted videos)
                - You would need to track which videos were removed in your component
                - Then call a delete API for each removed video
            ----------------------------------------------------------*/

            // Reset form states if needed
            if (typeof setVideoInputs === "function") setVideoInputs(initialVideoValues);

            // Clear form fields after successful save
            if (ImageSet) {
              // Clear ImageSet if you have setImageSet function
              // setImageSet(null);
            }

            if (videoset) {
              // Clear videoset state after saving
              if (typeof setvideoset === "function") {
                setvideoset({ target: { name: "thumbnail", value: [] } });
              }
            }

            resolve(res);
          };

          // Step 3: Dispatch main program update only
          dispatch(updateProgramRequest(payload, programUpdateCallback));
        });
      };













// const getSaveVideosResponse = (response) => {
//     const leng = response?.data?.length - 1;
//     const id = response?.data[leng]?._id;
//     const keysArray = Object.keys(videoUrlsInputs);

//     if (response.type === 1) {
//     keysArray.map((item, index) => {
//         setTimeout(() => {
//         dispatch(
//             saveVideosUrlsAction({
//             apiPayloadRequest: {
//                 _id: id,
//                 type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
//                 url_link: videoUrlsInputs[item],
//             },
//             callback: (res) => {
//                 if (res?.type !== 1) {
//                 Toastiy("Failed to Video URLS");
//                 } else {
//                 setShowNavigationAlert(false);
//                 }
//             },
//             })
//         );
//         }, 500 * (index + 1));
//     });

//     keysArray.map((item, index) => {
//         setTimeout(() => {
//         dispatch(
//             saveVideosDownloadUrlsAction({
//             apiPayloadRequest: {
//                 _id: id,
//                 type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
//                 url_link: UdownloadrlsInputs[item],
//             },
//             callback: (res) => {
//                 if (res?.type !== 1) {
//                 Toastiy("Failed to Video Download URLS");
//                 } else {
//                 setShowNavigationAlert(false);
//                 }
//             },
//             })
//         );
//         }, 1000 * (index + 1));
//     });

//     keysArray.map((item, index) => {
//         setTimeout(() => {
//         dispatch(
//             saveVideosThumbNailUrlsAction({
//             apiPayloadRequest: {
//                 _id: id,
//                 type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
//                 url_link: tumbNailUrlsInputs[item],
//             },
//             callback: (res) => {
//                 if (res?.type !== 1) {
//                 Toastiy("Failed to Thumbnail URLS");
//                 } else {
//                 setShowNavigationAlert(false);
//                 // Toastiy("Video Saved Successfully!", 1);
//                 }
//             },
//             })
//         );
//         }, 500 * (index + 1));
//     });

//     keysArray.map((item, index) => {
//         setTimeout(() => {
//         if (commonVideoUrlsInputs[item]) {
//             dispatch(
//             saveCommonsUrlsAction({
//                 apiPayloadRequest: {
//                 _id: id,
//                 type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
//                 url_link: commonVideoUrlsInputs[item],
//                 },
//                 callback: (res) => {
//                 if (res?.type !== 1) {
//                     Toastiy("Failed to Thumbnail URLS");
//                 } else {
//                     setShowNavigationAlert(false);
//                     // Toastiy("Video Saved Successfully!", 1);
//                 }
//                 },
//             })
//             );
//         }
//         }, 600 * (index + 1));
//     });

//     keysArray.map((item, index) => {
//         setTimeout(() => {
//         if (previewUrlsInputs[item]) {
//             dispatch(
//             saveVideoPreviewUrlsAction({
//                 apiPayloadRequest: {
//                 _id: id,
//                 type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
//                 url_link: previewUrlsInputs[item],
//                 },
//                 callback: (res) => {
//                 if (res?.type !== 1) {
//                     Toastiy("Failed to Preview URLS");
//                 } else {
//                     setShowNavigationAlert(false);
//                     // Toastiy("Video Saved Successfully!", 1);
//                 }
//                 },
//             })
//             );
//         }
//         }, 600 * (index + 1));
//     });

//     selectedOptions.map((item, index) => {
//         setTimeout(() => {
//         dispatch(
//             saveVideosrelatedAction({
//             apiPayloadRequest: {
//                 _id: id,
//                 videoObjId: item?.value,
//             },
//             })
//         );
//         }, 600 * (index + 1));
//     });

//     layoutArray.map((item, index) => {
//         setTimeout(() => {
//         dispatch(
//             saveVideoLayoutAction({
//             apiPayloadRequest: {
//                 _id: item?._id,
//                 videoObjId: id,
//                 order: item?.order,
//                 // expiry: item?.expiry,
//                 // title: item?.title,
//                 // subtitle: item?.subtitle,
//             },
//             callback: (res) => {
//             },
//             })
//         );
//         }, 700 * (index + 1));
//     });
//     setTimeout(() => {
//         setLoading(false);
//         Toastiy("Video Updated Successfully!", 1);
//         navigate("/videos/all");
//     }, 3000);
//     } else {
//     Toastiy("Failed To Save Video");
//     }
//     setLoading(false);
// };

// mobileUploadUrl: '',
// webUploadUrl: '',
// tabletUploadUrl: '', saveVideosThumbNailUrlsAction

// const getSaveVideosResponse1 = (data, id, message) => {
//     if (data?.type === 1) {
//     Toastiy(message, data?.type);
//     dispatch(
//         saveVideosDownloadUrlsAction({
//         apiPayloadRequest: {
//             _id: id,
//             type_of_url: downloadValues,
//             url_link: downloadData,
//         },
//         callback: (res) =>
//             getSaveVideosResponse2(res, id, "Video Download Url Saved Sucessfully."),
//         })
//     );
//     } else {
//     Toastiy("Issue performing the operation, contact admin!!", data?.type);
//     }
// };

// const getSaveVideosResponse2 = (data, id, message) => {
//     if (data?.type === 1) {
//     Toastiy(message, data?.type);
//     dispatch(
//         saveVideosThumbNailUrlsAction({
//         apiPayloadRequest: {
//             _id: id,
//             type_of_url: thumbNailValues,
//             url_link: tumbNailData,
//         },
//         callback: (res) => getSaveVideosResponse3(res, "Video Tumbnail Url Saved Sucessfully."),
//         })
//     );
//     } else {
//     Toastiy("Issue performing the operation, contact admin!!", data?.type);
//     }
// };

const getSaveVideosResponse3 = (data, message) => {
    if (data?.type === 1) {
    Toastiy(message, data?.type);
    } else {
    Toastiy("Issue performing the operation, contact admin!!", data?.type);
    }
};

useEffect(() => {
    setLoading(true);
    dispatch(
    readLanguageAction({
        callback: getAllLanguageResponse,
    })
    );
}, []);

const fetchVideoDetails = () => {
    dispatch(
    readVideosAction({
        apiPayloadRequest: {
        _id: data?._id,
        },
        callback: (res) => {
        const data = res?.data[0];
        // setVideoInputs({
        //   _id: data?._id,
        //   video_title: data?.video_title || "",
        //   video_description: data?.video_description || "",
        // });

        setCurrentInputs({
            _id: data?._id,
            video_title: data?.video_title || "",
            video_description: data?.video_description || "",
            totalLikes: data?.totallikes || 0,
            totalViews: data?.video_views || 0,
        });

        setLanguagemeta(data?.languagemetas);
        // setVideoUrlsInputs({
        //   mobileUploadUrl:
        //     data?.urls?.filter((item) => item.type_of_url === "0")[0]
        //       .url_link || "",
        //   webUploadUrl:
        //     data?.urls?.filter((item) => item.type_of_url === "1")[0]
        //       .url_link || "",
        //   tabletUploadUrl:
        //     data?.urls?.filter((item) => item.type_of_url === "2")[0]
        //       .url_link || "",
        // });

        setVideoUrlsInputsCheck({
            mobileUploadUrl:
            data?.urls?.filter((item) => item.type_of_url === "0")[0].url_link || "",
            webUploadUrl: data?.urls?.filter((item) => item.type_of_url === "1")[0].url_link || "",
            tabletUploadUrl:
            data?.urls?.filter((item) => item.type_of_url === "2")[0].url_link || "",
        });

        // setDownloadUrlsInputs({
        //   mobileUploadUrl:
        //     data?.downloadurls?.filter(
        //       (item) => item.type_of_url === "0"
        //     )[0].url_link || "",
        //   webUploadUrl:
        //     data?.downloadurls?.filter(
        //       (item) => item.type_of_url === "1"
        //     )[0].url_link || "",
        //   tabletUploadUrl:
        //     data?.downloadurls?.filter(
        //       (item) => item.type_of_url === "2"
        //     )[0].url_link || "",
        // });

        setDownloadUrlsInputsCheck({
            mobileUploadUrl:
            data?.downloadurls?.filter((item) => item.type_of_url === "0")[0].url_link || "",
            webUploadUrl:
            data?.downloadurls?.filter((item) => item.type_of_url === "1")[0].url_link || "",
            tabletUploadUrl:
            data?.downloadurls?.filter((item) => item.type_of_url === "2")[0].url_link || "",
        });

        setTumbNailUrlsInputsCheck({
            mobileUploadUrl:
            data?.tumbnailurls?.filter((item) => item.type_of_url === "0")[0].url_link || "",
            webUploadUrl:
            data?.tumbnailurls?.filter((item) => item.type_of_url === "1")[0].url_link || "",
            tabletUploadUrl:
            data?.tumbnailurls?.filter((item) => item.type_of_url === "2")[0].url_link || "",
        });

        setCommonUrlsInputsCheck({
            mobileUploadUrl:
            data?.gnerictumbnailurls?.filter((item) => item.type_of_url === "0")[0].url_link ||
            "",
            webUploadUrl:
            data?.gnerictumbnailurls?.filter((item) => item.type_of_url === "1")[0].url_link ||
            "",
            tabletUploadUrl:
            data?.gnerictumbnailurls?.filter((item) => item.type_of_url === "2")[0].url_link ||
            "",
        });

        setPreviewUrlsInputsCheck({
            mobileUploadUrl:
            data?.trailers?.filter((item) => item.type_of_url === "0")[0].url_link || "",
            webUploadUrl:
            data?.trailers?.filter((item) => item.type_of_url === "1")[0].url_link || "",
            tabletUploadUrl:
            data?.trailers?.filter((item) => item.type_of_url === "2")[0].url_link || "",
        });

        // const isValidRelatedVideos = data?.relatedvideos?.find((v) => v?.videoObjId?.length > 0);
        // const relatedVideos = isValidRelatedVideos ? data?.relatedvideos : [];
        const relatedVideos = data?.relatedvideos ?? [];
        const relatedVideosList = [];
        relatedVideos.map((item) => {
            relatedVideosList.push({
            value: item?.videoObjId?._id,
            label: item?.videoObjId?.video_title,
            image: item?.videoObjId?.tumbnailurls[0].url_link,
            });
        });
        setSelectedOptions(relatedVideosList);
        },
    })
    );
};

const fetchVideoLayouts = () => {
    dispatch(
    readVideoLayoutAction({
        apiPayloadRequest: {
        videoObjId: data?._id,
        },
        callback: (res) => {
        if (res?.type === 1) {
                        res?.data.forEach((layout) => {
            const requiredData = layout.videos.filter((item) => item.videoObjId === data?._id);

            const requiredId = layout._id;
            const requiredMobileLayout = layout.mobile_layout;
            const requiredName = layout.layout_name;

            requiredData.map((item) => {
                setLayoutArray((prev) => [
                ...prev,
                {
                    _id: requiredId,
                    mobile_layout: requiredMobileLayout,
                    layout_name: requiredName,
                    order: item.order,
                    // title: item.title,
                    // subtitle: item.subtitle,
                    // expiry: item.expiry,
                },
                ]);
            });
            });
        }
        },
    })
    );
};

// useEffect(() => {
//     if (data?._id !== "" && data?._id !== undefined) {
    // setTimeout(() => {
    //   dispatch(readVideosAction({ callback: getRelatedVideos }));
    // }, 2000);

//     fetchVideoDetails();
//     fetchVideoLayouts();
//     } else {
//     dispatch(readVideosAction({ callback: getRelatedVideos }));
//     }
// }, []);

const [isLanguageSave, setIsLanguageSave] = useState(true);
const [currentLanguageInputs, setCurrentLanguageInputs] = useState();
const [currentLanguageUrlCheck, setCurrentLanguageUrlCheck] = useState();
const [currentLanguageDownloadUrlCheck, setCurrentLanguageDownloadUrlCheck] = useState();
const [currentLanguagePreviewUrlCheck, setCurrentLanguagePreviewUrlCheck] = useState();


useEffect(() => {
    if (activeTab === "en") {
    if (currentInputs) {
        setVideoInputs(currentInputs);
    }
    if (videoUrlsInputsCheck) {
        setVideoUrlsInputs(videoUrlsInputsCheck);
    }
    if (UdownloadrlsInputsCheck) {
        setDownloadUrlsInputs(UdownloadrlsInputsCheck);
    }
    if (tumbNailUrlsInputsCheck) {
        setTumbNailUrlsInputs(tumbNailUrlsInputsCheck);
    }
    if (commonUrlsInputsCheck) {
        setCommonUrlsInputs(commonUrlsInputsCheck);
    }
    if (previewUrlsInputsCheck) {
        setPreviewUrlsInputs(previewUrlsInputsCheck);
    }
    } else {
    const isPresent = languagemeta?.some((language) => language?.language_code === activeTab);
    if (isPresent) {
        const data = languagemeta?.filter((item) => item?.language_code === activeTab)[0];

        setVideoInputs((prev) => ({
        ...prev,
        video_title: data?.video_title || "",
        video_description: data?.video_description || "",
        }));
        setCurrentLanguageInputs((prev) => ({
        ...prev,
        video_title: data?.video_title || "",
        video_description: data?.video_description || "",
        }));

        if (data?.urls?.length > 0) {
        setVideoUrlsInputs({
            mobileUploadUrl:
            data?.urls?.filter((item) => item?.type_of_url === "0")?.[0]?.url_link || "",
            webUploadUrl:
            data?.urls?.filter((item) => item?.type_of_url === "1")?.[0]?.url_link || "",
            tabletUploadUrl:
            data?.urls?.filter((item) => item?.type_of_url === "2")?.[0]?.url_link || "",
        });
        setCurrentLanguageUrlCheck({
            mobileUploadUrl:
            data?.urls?.filter((item) => item?.type_of_url === "0")?.[0]?.url_link || "",
            webUploadUrl:
            data?.urls?.filter((item) => item?.type_of_url === "1")?.[0]?.url_link || "",
            tabletUploadUrl:
            data?.urls?.filter((item) => item?.type_of_url === "2")?.[0]?.url_link || "",
        });
        } else {
        setVideoUrlsInputs(initialStateValues);
        setCurrentLanguageUrlCheck(initialStateValues);
        }
        if (data?.downloadurls?.length > 0) {
        setDownloadUrlsInputs({
            mobileUploadUrl:
            data?.downloadurls?.filter((item) => item?.type_of_url === "0")?.[0]?.url_link || "",
            webUploadUrl:
            data?.downloadurls?.filter((item) => item?.type_of_url === "1")?.[0]?.url_link || "",
            tabletUploadUrl:
            data?.downloadurls?.filter((item) => item?.type_of_url === "2")?.[0]?.url_link || "",
        });
        setCurrentLanguageDownloadUrlCheck({
            mobileUploadUrl:
            data?.downloadurls?.filter((item) => item?.type_of_url === "0")?.[0]?.url_link || "",
            webUploadUrl:
            data?.downloadurls?.filter((item) => item?.type_of_url === "1")?.[0]?.url_link || "",
            tabletUploadUrl:
            data?.downloadurls?.filter((item) => item?.type_of_url === "2")?.[0]?.url_link || "",
        });
        } else {
        setDownloadUrlsInputs(initialStateValues);
        setCurrentLanguageDownloadUrlCheck(initialStateValues);
        }
        if (data?.trailers?.length > 0) {
        setPreviewUrlsInputs({
            mobileUploadUrl:
            data?.trailers?.filter((item) => item?.type_of_url === "0")?.[0]?.url_link || "",
            webUploadUrl:
            data?.trailers?.filter((item) => item?.type_of_url === "1")?.[0]?.url_link || "",
            tabletUploadUrl:
            data?.trailers?.filter((item) => item?.type_of_url === "2")?.[0]?.url_link || "",
        });
        setCurrentLanguagePreviewUrlCheck({
            mobileUploadUrl:
            data?.trailers?.filter((item) => item?.type_of_url === "0")?.[0]?.url_link || "",
            webUploadUrl:
            data?.trailers?.filter((item) => item?.type_of_url === "1")?.[0]?.url_link || "",
            tabletUploadUrl:
            data?.trailers?.filter((item) => item?.type_of_url === "2")?.[0]?.url_link || "",
        });
        } else {
        setPreviewUrlsInputs(initialStateValues);
        setCurrentLanguagePreviewUrlCheck(initialStateValues);
        }
    } else {
        setVideoInputs(currentInputs);
        setCurrentLanguageInputs(currentInputs);
        setVideoUrlsInputs(initialStateValues);
        setCurrentLanguageUrlCheck(initialStateValues);
        setDownloadUrlsInputs(initialStateValues);
        setCurrentLanguageDownloadUrlCheck(initialStateValues);
        setPreviewUrlsInputs(initialStateValues);
        setCurrentLanguagePreviewUrlCheck(initialStateValues);
    }
    }
}, [
    activeTab,
    videoUrlsInputsCheck,
    UdownloadrlsInputsCheck,
    tumbNailUrlsInputsCheck,
    commonUrlsInputsCheck,
    previewUrlsInputsCheck,
]);


const handleSaveLanguage = async () => {
    const requestsList = [];
    if (isLanguageSave) {
    const keysArray = Object.keys(videoUrlsInputs);
  const apiPayloadRequest = {
            _id: data?.church?._id,
            language_code: activeTab,
            programName: videoInputs?.programName,
            description: videoInputs?.description,
            placename: videoInputs?.placename,
            liveStreamUrl: videoInputs?.liveStreamUrl,
            contactemail: videoInputs?.contactemail,

          };
                requestsList.push(
            new Promise((resolve, reject) => {

                dispatch(
                    saveProgramLanguageMetaRequest(apiPayloadRequest, (res) => {
                      if (res?.type === 1) {
                        setShowNavigationAlert(false);
                      }
                      resolve();
                    })
                  );
            })
        );

    keysArray.map((item, index) => {
        requestsList.push(
        new Promise((resolve, reject) => {
            setTimeout(() => {
            if (videoUrlsInputs[item]) {
                dispatch(
                saveVideoUrlLanguageAction({
                    apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: videoUrlsInputs[item],
                    },
                    callback: (res) => {
                    if (res?.type === 1) {
                        Toastiy("Video URLs Saved Successfully", 1);
                        setShowNavigationAlert(false);
                    }
                    resolve();
                    },
                })
                );
            } else {
                resolve();
            }
            }, (index + 1) * 500);
        })
        );
    });

    keysArray.map((item, index) => {
        requestsList.push(
        new Promise((resolve, reject) => {
            setTimeout(() => {
            if (UdownloadrlsInputs[item]) {
                dispatch(
                saveDownloadVideoUrlLanguageAction({
                    apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: UdownloadrlsInputs[item],
                    },
                    callback: (res) => {
                    if (res?.type === 1) {
                        Toastiy("Video Download URLs Saved Successfully", 1);
                        setShowNavigationAlert(false);
                    }
                    resolve();
                    },
                })
                );
            } else {
                resolve();
            }
            }, (index + 1) * 600);
        })
        );
    });

    keysArray.map((item, index) => {
        requestsList.push(
        new Promise((resolve, reject) => {
            setTimeout(() => {
            if (previewUrlsInputs[item]) {
                dispatch(
                saveVideoPreviewLanguageAction({
                    apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: previewUrlsInputs[item],
                    },
                    callback: (res) => {
                    if (res?.type === 1) {
                        Toastiy("Video Preview URLs Saved Successfully", 1);
                        setShowNavigationAlert(false);
                    }
                    resolve();
                    },
                })
                );
            } else {
                resolve();
            }
            }, (index + 1) * 650);
        })
        );
    });
    } else {
    const keysArray = Object.keys(videoUrlsInputs);

    if (
        videoInputs?.video_title !== currentLanguageInputs?.video_title ||
        videoInputs?.video_description !== currentLanguageInputs?.video_description
    ) {
        requestsList.push(
        new Promise((resolve, reject) => {
            dispatch(
            updateVideoLanguageAction({
                apiPayloadRequest: {
                _id: data?._id,
                language_code: activeTab,
                video_title: videoInputs?.video_title,
                video_description: videoInputs?.video_description,
                },
                callback: (res) => {
                if (res?.type === 1) {
                    Toastiy("Video Language Updated Successfully", 1);
                    setShowNavigationAlert(false);
                }
                resolve();
                },
            })
            );
        })
        );
    }

    keysArray.map((item) => {
        if (!currentLanguageUrlCheck[item] && videoUrlsInputs[item]) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                saveVideoUrlLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: videoUrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        } else if (
        videoUrlsInputs[item] &&
        videoUrlsInputs[item] !== currentLanguageUrlCheck[item]
        ) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                updateVideoUrlLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: videoUrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        }
    });

    keysArray.map((item) => {
        if (!currentLanguageDownloadUrlCheck[item] && UdownloadrlsInputs[item]) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                saveDownloadVideoUrlLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: UdownloadrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video Download URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        } else if (
        UdownloadrlsInputs[item] &&
        UdownloadrlsInputs[item] !== currentLanguageDownloadUrlCheck[item]
        ) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                updateDownloadVideoUrlLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: UdownloadrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video Download URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        }
    });

    keysArray.map((item) => {
        if (!currentLanguagePreviewUrlCheck[item] && previewUrlsInputs[item]) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                saveVideoPreviewLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: previewUrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video Preview URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        } else if (
        previewUrlsInputs[item] &&
        previewUrlsInputs[item] !== currentLanguagePreviewUrlCheck[item]
        ) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                updateVideoPreviewLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: previewUrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video Preview URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        }
    });
    }

    await Promise.all(requestsList);
    fetchVideoDetails();
};

const handleLibraryVideoSelection = (details) => {
        setVideoInputs((prev) => ({
    ...prev,
    video_title: details?.video_title,
    video_description: details?.video_description,
    }));
    setVideoUrlsInputs({
    mobileUploadUrl: details?.urls?.find((d) => d?.type_of_url === "0")?.url_link,
    webUploadUrl: details?.urls?.find((d) => d?.type_of_url === "1")?.url_link,
    tabletUploadUrl: details?.urls?.find((d) => d?.type_of_url === "2")?.url_link,
    });
    setDownloadUrlsInputs({
    mobileUploadUrl: details?.downloadurls?.find((d) => d?.type_of_url === "0")?.url_link,
    webUploadUrl: details?.downloadurls?.find((d) => d?.type_of_url === "1")?.url_link,
    tabletUploadUrl: details?.downloadurls?.find((d) => d?.type_of_url === "2")?.url_link,
    });
    setTumbNailUrlsInputs({
    mobileUploadUrl: details?.tumbnailurls?.find((d) => d?.type_of_url === "0")?.url_link,
    webUploadUrl: details?.tumbnailurls?.find((d) => d?.type_of_url === "1")?.url_link,
    tabletUploadUrl: details?.tumbnailurls?.find((d) => d?.type_of_url === "2")?.url_link,
    });
    setCommonUrlsInputs({
    mobileUploadUrl: details?.gnerictumbnailurls?.find((d) => d?.type_of_url === "0")?.url_link,
    webUploadUrl: details?.gnerictumbnailurls?.find((d) => d?.type_of_url === "1")?.url_link,
    tabletUploadUrl: details?.gnerictumbnailurls?.find((d) => d?.type_of_url === "2")?.url_link,
    });
    setShowNavigationAlert(true);
};

const handleSendNotification = () => {
    dispatch(
    sendCustomNotificationAction({
        apiPayloadRequest: {
        _id: data?._id,
        type: "2",
        },
        callback: (res) => {
        if (res?.type === 1) {
            Toastiy("Notification Sent Successfully", 1);
        }
        },
    })
    );
};

return {
    value,
    onChangeSearchBar,
    languages,
    activeTab,
    setActiveTab,
    activeLanguageDetails,
    setActiveLanguageDetails,
    inputs,
    handleInputChange,
    handleFileInputChange,
    handleRelatedVideosChange,
    handleVideoDescriptionChange,
    handleSave,
    // handleSaveCarecellCoverImage,
    readLanguageData,
    videoInputs,
    videoErrors,
    showVideoLibraryModal,
    setShowVideoLibraryModal,
    setVideoUrlsInputs,
    setDownloadUrlsInputs,
    setTumbNailUrlsInputs,
    videoUrlsInputs,
    handleFileDownloadInputChange,
    handleFiletumbNailInputChange,
    tumbNailUrlsInputs,
    UdownloadrlsInputs,
    handleChange,
    handleCarecellChange,
    handleTumbNailInputChange,
    handleDownloadInputChange,
    selectedOptions,
    setSelectedOptions,
    deleteRelatedVideo,
    setSelectedRelatedVideoIndex,
    handleDropdownChange,
    setLayoutValues,
    handleVideoLayoutChange,
    layoutValues,
    initialLayoutValues,
    setLayoutInfo,
    layoutInfo,
    handleDateChange,
    handleAddLayoutToArray,
    layoutArray,
    setAddedLayout,
    addedLayout,
    handleVideoDateChange,
    options,
    handleDeleteLayoutFromArray,
    setIsLayoutEdit,
    setEditLayoutIndex,
    isLayoutEdit,
    handleLayoutUpdate,
    setEditTargetLayout,
    editTargetLayout,
    updateStateWithTranslation,
    handleCommonTumbNailInputChange,
    setCommonUrlsInputs,
    commonVideoUrlsInputs,
    previewUrlsInputs,
    setPreviewUrlsInputs,
    languagemeta,
    setIsLanguageSave,
    handleSaveLanguage,
    handleLibraryVideoSelection,
    currentInputs,
    handleSendNotification,
    churchInputs, // instead of videoInputs
    churchErrors, // instead of videoErrors
    handleChange,
    setcarecellInputs,
    handleSave,
    handleUpdateChurch,
    setImageSet,
    setLanguagemeta,videoInputs, setVideoInputs,
    thumbnailImage, setThumbnailImage,
    isLive,setIslive,
    isDefault,setIsDefault,
    setvideoset

};
};
